import { useState } from 'react';
import type { FaqItem } from '@/types';

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string>(items[0]?.id ?? '');

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className={`overflow-hidden rounded-lg border transition-colors ${
              isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-100/60'
            }`}
          >
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenId(isOpen ? '' : item.id)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
              >
                <span className="flex items-start gap-3 font-heading text-sm font-bold text-foreground-950 md:text-base">
                  <i
                    className={`ri-question-line mt-0.5 ${isOpen ? 'text-primary-500' : 'text-foreground-400'}`}
                    aria-hidden="true"
                  />
                  {item.question}
                </span>
                <i
                  className={`shrink-0 text-lg transition-transform duration-300 ${
                    isOpen ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                  } ri-arrow-down-s-line`}
                  aria-hidden="true"
                />
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 pb-4 pl-11 text-[13px] leading-relaxed text-foreground-600 md:px-5 md:pl-12 md:text-sm">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}